import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { FiEye, FiFilter, FiShoppingBag, FiCalendar } from "react-icons/fi";
import InfoHeader from "../components/InfoHeader";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "../styles/coriander.css";
import { Justify } from "react-bootstrap-icons";
import { fetchCorianderDetailedData, saveActualCount } from "../components/API/Api";

const RowSaveButton = ({ rowKey, saveCallbacksRef, onSave, hasExistingValue }) => {
    const [enabled, setEnabled] = useState(!!hasExistingValue);
    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(false);
    const [isUpdate, setIsUpdate] = useState(!!hasExistingValue);

    useEffect(() => {
        saveCallbacksRef.current[rowKey] = (hasValue) => setEnabled(hasValue);
        return () => { delete saveCallbacksRef.current[rowKey]; };
    }, [rowKey, saveCallbacksRef]);

    const handleClick = async () => {
        setSaving(true);
        const success = await onSave();
        setSaving(false);
        if (success) {
            setSaved(true);
            setIsUpdate(true);
            setTimeout(() => setSaved(false), 2000);
        }
    };

    return (
        <button
            disabled={!enabled || saving}
            onClick={handleClick}
            style={{
                padding: "4px 10px",
                fontSize: "12px",
                border: "none",
                borderRadius: "4px",
                cursor: enabled && !saving ? "pointer" : "not-allowed",
                backgroundColor: saved ? "#28a745" : enabled ? "#0d6efd" : "#ccc",
                color: "#fff",
                minWidth: "55px",
            }}
        >
            {saving ? "..." : saved ? "\u2713" : isUpdate ? "Update" : "Save"}
        </button>
    );
};

export default function Coriander() {
    const [showModal, setShowModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");
    const [modalTitle, setModalTitle] = useState("");

    // Date range state using PrimeReact Calendar format (array of dates)
    const [dateRange, setDateRange] = useState([new Date(), new Date()]);

    // API data states
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        rowsPerPage: 5,
    });

    // Separate API metrics (from backend) and displayed metrics (for filtered data)
    const [apiMetrics, setApiMetrics] = useState({
        totalSackCount: 0,
        totalThreadCount: 0,
        lastThreadTimestamp: null,
    });

    const [displayMetrics, setDisplayMetrics] = useState({
        totalSackCount: 0,
        totalThreadCount: 0,
        lastThreadTimestamp: null,
    });

    const actualCountsRef = React.useRef({});
    const saveCallbacksRef = React.useRef({});

    const handleActualCountChange = (key, value) => {
        actualCountsRef.current[key] = value;
        if (saveCallbacksRef.current[key]) saveCallbacksRef.current[key](!!value);
    };

    const handleSaveActualCount = async (rowData) => {
        const key = `${rowData.date}_${rowData.time}`;
        const actualCount = actualCountsRef.current[key];
        try {
            const payload = {
                section: "coriander#hourly#count",
                date: rowData.date,
                time: rowData.time,
                shift: rowData.shift,
                actual_sack_count: Number(actualCount) || 0,
            };
            const response = await saveActualCount(payload);
            if (response.success) {
                setData(prev => prev.map(item =>
                    `${item.date}_${item.time}` === key
                        ? { ...item, actual_sack_count: Number(actualCount) || 0 }
                        : item
                ));
                return true;
            } else {
                alert(response.error || "Failed to save actual count");
                return false;
            }
        } catch (err) {
            alert("Error saving actual count: " + err.message);
            return false;
        }
    };

    // Added shift filter state
    const [shiftFilter, setShiftFilter] = useState(null);
    const shiftOptions = [
        { label: "All Shifts", value: null },
        { label: "Shift I", value: "I" },
        { label: "Shift II", value: "II" },
    ];

    // Format date for API request
    const formatDateForAPI = (date) => {
        if (!date) return "";

        // Use toLocaleDateString with 'en-CA' locale for YYYY-MM-DD format
        return date.toLocaleDateString('en-CA');
    };

    // const fetchData = async (
    //     page = 1,
    //     startDate = null,
    //     endDate = null,
    //     rowsPerPageValue = null
    // ) => {
    //     setLoading(true);
    //     setError(null);

    //     try {
    //         const start = startDate
    //             ? formatDateForAPI(startDate)
    //             : formatDateForAPI(new Date());
    //         const end = endDate
    //             ? formatDateForAPI(endDate)
    //             : formatDateForAPI(new Date());

    //         const noOfRecords = rowsPerPageValue || pagination.rowsPerPage;

    //         const endpoint = `https://g1e3kx0ij7.execute-api.ap-south-1.amazonaws.com/testing/coriander_history?start_date=${start}&end_date=${end}&page_no=${page}&no_of_records=${noOfRecords}`;

    //         const response = await axios.get(endpoint);

    //         // Check if the response has the expected structure
    //         if (
    //             response.data &&
    //             response.data.statusCode === 200 &&
    //             response.data.body &&
    //             response.data.body.success
    //         ) {
    //             const successData = response.data.body.success;
    //             console.log("success data -->>", successData);

    //             // Process data to separate date and time
    //             const processedData = (successData.data || []).map((item) => {
    //                 // Assuming timestamp_range is in format "DD-MM-YY HH:MM AM/PM to DD-MM-YY HH:MM AM/PM"
    //                 const parts = item.timestamp_range.split(" ");

    //                 // Extract date (DD-MM-YY) and convert to DD-MM-YYYY format
    //                 const dateStr = parts[0]; // Format: DD-MM-YY
    //                 const dateParts = dateStr.split("-");
    //                 if (dateParts.length === 3) {
    //                     // Convert 2-digit year to 4-digit year
    //                     let year = dateParts[2];
    //                     if (year.length === 2) {
    //                         // Assuming 20xx for years (can be adjusted based on requirements)
    //                         year = "20" + year;
    //                     }
    //                     // Format as DD-MM-YYYY
    //                     dateParts[2] = year;
    //                     const formattedDate = dateParts.join("-");

    //                     const time = `${parts[1]} ${parts[2]} - ${parts[5]} ${parts[6]}`; // Extract time (HH:MM AM/PM - HH:MM AM/PM)

    //                     // Determine shift based on time
    //                     const timeStr = parts[1] + " " + parts[2];
    //                     let hour = parseInt(timeStr.split(":")[0]);
    //                     const isPM = timeStr.includes("PM");

    //                     if (isPM && hour !== 12) hour += 12;
    //                     if (!isPM && hour === 12) hour = 0;

    //                     // Shift I: 6 AM to 6 PM, Shift II: 6 PM to 6 AM
    //                     const shift = hour >= 6 && hour < 18 ? "I" : "II";

    //                     return {
    //                         ...item,
    //                         date: formattedDate,
    //                         time,
    //                         shift,
    //                     };
    //                 } else {
    //                     // Fallback if date format is unexpected
    //                     return {
    //                         ...item,
    //                         date: dateStr,
    //                         time: `${parts[1]} ${parts[2]} - ${parts[5]} ${parts[6]}`,
    //                         shift: "I", // Default to Shift I if we can't determine
    //                     };
    //                 }
    //             });

    //             // Log data for debugging
    //             console.log("API data received:", processedData);

    //             // Update data state
    //             setData(processedData);
    //             setOriginalData(processedData); // Store original data for filtering

    //             // Update pagination state, making sure to maintain the selected rowsPerPage
    //             setPagination({
    //                 currentPage: successData.page_no || 1,
    //                 totalPages: successData.total_pages || 1,
    //                 totalRecords: successData.total_records || 0,
    //                 rowsPerPage: rowsPerPageValue || pagination.rowsPerPage,
    //             });

    //             // IMPORTANT FIX: Store the API metrics separately
    //             setApiMetrics({
    //                 totalSackCount: successData.total_sack_count || 0,
    //                 totalThreadCount: successData.total_thread_count || 0,
    //                 lastThreadTimestamp: successData.last_thread_timestamp,
    //             });

    //             // Initially set display metrics same as API metrics
    //             setDisplayMetrics({
    //                 totalSackCount: successData.total_sack_count || 0,
    //                 totalThreadCount: successData.total_thread_count || 0,
    //                 lastThreadTimestamp: successData.last_thread_timestamp,
    //             });
    //         } else {
    //             throw new Error("Unexpected API response format");
    //         }
    //     } catch (err) {
    //         console.error("Error fetching data:", err);
    //         setError("Failed to fetch data. Please try again later.");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const fetchData = async (
        page = 1,
        startDate = null,
        endDate = null,
        rowsPerPageValue = null
    ) => {
        setLoading(true);
        setError(null);

        try {
            // Call the detailed API function
            const result = await fetchCorianderDetailedData(
                page,
                startDate,
                endDate,
                rowsPerPageValue,
                pagination
            );

            if (result.success) {
                const {
                    processedData,
                    originalData,
                    pagination: newPagination,
                    apiMetrics,
                    displayMetrics
                } = result.data;

                // Pre-populate actualCountsRef with existing actual counts
                actualCountsRef.current = {};
                processedData.forEach(item => {
                    if (item.actual_sack_count != null && item.actual_sack_count !== "") {
                        const key = `${item.date}_${item.time}`;
                        actualCountsRef.current[key] = String(item.actual_sack_count);
                    }
                });

                // Update data state with processed data (includes date, time, shift)
                setData(processedData);
                setOriginalData(originalData); // Store original data for filtering

                // Update pagination state
                setPagination(newPagination);

                // IMPORTANT: Store the API metrics separately
                setApiMetrics(apiMetrics);

                // Initially set display metrics same as API metrics
                setDisplayMetrics(displayMetrics);

                // Clear any existing errors
                setError(null);

                console.log("Detailed data loaded successfully:", processedData);

            } else {
                setError("Failed to fetch data. Please try again later.");
                console.error("API Error:", result.error);
            }
        } catch (err) {
            console.error("Error in loadDetailedCorianderData:", err);
            setError("Failed to fetch data. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    // Initialize data on component mount
    useEffect(() => {
        // Set default date range to today (start and end)
        const today = new Date();
        setDateRange([today, today]);
        fetchData(1, today, today);

    }, []);

    // Handle date range filter application
    const applyDateFilter = () => {
        if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
            fetchData(1, dateRange[0], dateRange[1]);
            // Reset shift filter when applying date filter
            setShiftFilter(null);
        }
    };

    // Added filter by shift function
    useEffect(() => {
        // Make sure originalData exists and has items before proceeding
        if (!originalData || originalData.length === 0) {
            return;
        }

        if (shiftFilter === null) {
            // If no shift filter, show original data
            setData([...originalData]);

            // IMPORTANT FIX: When showing all data, use the API metrics
            setDisplayMetrics({
                ...apiMetrics,
            });
        } else {
            // Filter data by shift
            const filteredData = originalData.filter(
                (item) => item.shift === shiftFilter
            );
            setData(filteredData);

            // CHANGE: For table data only, calculate filtered metrics
            // Note: We're not changing the main metrics displayed at the top
            // const filteredTableMetrics = {
            //     totalSackCount: filteredData.reduce(
            //         (sum, item) => sum + (parseInt(item.sack) || 0),
            //         0
            //     ),
            //     totalThreadCount: filteredData.reduce(
            //         (sum, item) => sum + (parseInt(item.thread) || 0),
            //         0
            //     ),
            //     lastThreadTimestamp: apiMetrics.lastThreadTimestamp,
            // };

            // OPTIONAL: If you want to show filtered counts in the UI when a shift is selected
            // Uncomment this line:
            // setDisplayMetrics(filteredTableMetrics);

            // Or keep using the API metrics regardless of filtering:
            setDisplayMetrics({
                ...apiMetrics,
            });
        }
    }, [shiftFilter, originalData, apiMetrics]);

    useEffect(() => {
        if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
            // Add a small delay to avoid too frequent API calls
            const timeoutId = setTimeout(() => {
                fetchData(1, dateRange[0], dateRange[1]);
                setShiftFilter(null); // Reset shift filter
            }, 500);

            return () => clearTimeout(timeoutId);
        }
    }, [dateRange]);

    const clearDateFilter = () => {
        const today = new Date();
        setDateRange([today, today]);
        setShiftFilter(null);
        fetchData(1, today, today);
    };

    // Handle page change
    const handlePageChange = (page) => {
        if (page < 1 || page > pagination.totalPages) return;

        fetchData(
            page,
            dateRange && dateRange.length === 2 ? dateRange[0] : null,
            dateRange && dateRange.length === 2 ? dateRange[1] : null
        );
    };



    // Handle rows per page change
    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = Number(e.target.value);

        // Update pagination state with new rowsPerPage
        setPagination((prev) => ({
            ...prev,
            rowsPerPage: newRowsPerPage,
            currentPage: 1, // Reset to first page when changing rows per page
        }));

        // Fetch data with the new rowsPerPage value directly (don't rely on state update)
        fetchData(
            1, // Reset to first page when changing rows per page
            dateRange && dateRange.length === 2 ? dateRange[0] : null,
            dateRange && dateRange.length === 2 ? dateRange[1] : null,
            newRowsPerPage // Pass the new rowsPerPage value directly
        );
    };

    function MetricCard({ title, value, icon, isTimestamp = false }) {
        return (
            <div className="metric-card">
                <div className="p-3">
                    <div className="metric-title">{title}</div>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className={`metric-value ${isTimestamp ? "timestamp" : ""}`}>
                            {value}
                        </div>
                        <div>{icon}</div>
                    </div>
                </div>
            </div>
        );
    }

    const filterContainerStyle = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "15px",
    };

    const tableContainerStyle = {
        width: "100%",
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        padding: "15px",
        display: "flex",
        flexDirection: "column",
        minHeight: "400px",
        marginBottom: "20px",
    };

    const tableHeadingStyle = {
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "18px",
        marginBottom: "15px",
        color: "#007BFF",
        justifyContent: "end",
        alignItems: "center",
    };

    <DataTable
        value={data}
        scrollable
        scrollHeight="250px"
        // className="p-datatable-sm p-datatable-striped"
        className="myCustomTable p-datatable-sm p-datatable-striped"
        emptyMessage="No records found for selected date range"
        responsiveLayout="scroll"
        loading={loading}
    >
        <Column
            header="Sr. No."
            style={{ width: "5%" }}
            bodyStyle={{ textAlign: "right" }}
            body={(rowData, options) => (
                <span>
                    {(pagination.currentPage - 1) * pagination.rowsPerPage +
                        options.rowIndex +
                        1}
                </span>
            )}
        />
        <Column field="date" header="Date" style={{ width: "12%" }} />
        <Column
            field="time"
            header="Time"
            style={{ width: "15%" }}
            body={(rowData) => (
                <span
                    style={{ cursor: "pointer", color: "black" }}
                    onClick={() => {
                        setShowModal(true);
                        setSelectedImage("/Sack_Count.png");
                        setModalTitle("Sack Emptying Count Details");
                    }}
                >
                    {rowData.time}
                </span>
            )}
        />
        <Column
            field="shift"
            header="Shift"
            style={{ width: "7%" }}
            bodyStyle={{ textAlign: "center" }}
        />
        <Column
            field="thread"
            header="Thread Count"
            style={{ width: "10%" }}
            headerStyle={{ textAlign: "center" }}
            bodyClassName="text-left bg-light-blue"
        />
        <Column
            field="sack"
            header="Detected Sack Count"
            style={{ width: "13%" }}
            headerStyle={{ textAlign: "center" }}
            bodyClassName="text-left bg-light-gray"
        />
        <Column
            header="Actual Sack Count"
            style={{ width: "13%" }}
            headerStyle={{ textAlign: "center" }}
            body={(rowData) => (
                <input
                    type="text"
                    inputMode="numeric"
                    defaultValue={rowData.actual_sack_count != null && rowData.actual_sack_count !== "" ? rowData.actual_sack_count : ""}
                    onChange={(e) =>
                        handleActualCountChange(
                            `${rowData.date}_${rowData.time}`,
                            e.target.value
                        )
                    }
                    placeholder="Enter count"
                    style={{
                        width: "100%",
                        padding: "4px 8px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                        textAlign: "right",
                    }}
                />
            )}
        />
        <Column
            header="Action"
            style={{ width: "7%" }}
            bodyStyle={{ textAlign: "center" }}
            body={(rowData) => (
                <RowSaveButton
                    rowKey={`${rowData.date}_${rowData.time}`}
                    saveCallbacksRef={saveCallbacksRef}
                    onSave={() => handleSaveActualCount(rowData)}
                    hasExistingValue={rowData.actual_sack_count != null && rowData.actual_sack_count !== ""}
                />
            )}
        />
    </DataTable>

    const paginationContainerStyle = {
        marginTop: "auto",
        padding: "14px",
        borderTop: "1px solid #eee",
    };

    const dateFilterContainerStyle = {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "start",
        alignItems: "center",
        padding: "0 15px",
        borderRadius: "8px",
        marginBottom: "20px",
        gap: "15px",
    };

    const SackTableEyeOnClick = () => {
        setShowModal(true);
        setSelectedImage("/Sack_Count.png");
        setModalTitle("Sack Emptying Count View");
    };

    // Format date range for display
    const getDateRangeText = () => {
        if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
            const formatDate = (date) => {
                return date.toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                });
            };

            return `${formatDate(dateRange[0])} to ${formatDate(dateRange[1])}`;
        }
        return "Today";
    };

    return (
        <div
            className="col-lg-12"
            style={{
                maxHeight: "90vh",
                overflowY: "scroll",
                overflowX: "hidden",
            }}
        >
            <div>
                <InfoHeader />
            </div>
            <div className="card border dashboard-card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h2 className="fs-5 fw-semibold mb-0">Coriander</h2>
                </div>
                <div className="card-body">
                    <div style={dateFilterContainerStyle}>
                        <div className="d-flex align-items-center">
                            <FiCalendar className="me-2" size={18} />
                            <span className="fw-semibold">Filter by Date Range:</span>
                        </div>
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <Calendar
                                value={dateRange}
                                onChange={(e) => setDateRange(e.value)}
                                selectionMode="range"
                                readOnlyInput
                                showIcon
                                placeholder="Select Date Range"
                                maxDate={new Date()}
                                className="p-calendar-range"
                                dateFormat="dd/mm/yy"
                                hideOnDateTimeSelect={true}
                            // closeOnSelect={true}
                            />
                            <Button
                                label="Apply Filter"
                                icon="pi pi-filter"
                                onClick={applyDateFilter}
                                disabled={loading}
                                className="p-button-md p-button-primary"
                            />
                            <Button
                                // label="Clear Filter"
                                icon="pi pi-times"
                                onClick={clearDateFilter}
                                disabled={loading}
                                className="p-button-md p-button-primary"
                            />
                        </div>
                        <div style={tableHeadingStyle}>
                            {/* <div className="small text-muted mt-1">
                                Showing data for: {getDateRangeText()}
                                {shiftFilter ? ` | Shift: ${shiftFilter}` : ""}
                            </div> */}
                        </div>
                    </div>
                    <div className="row g-3">
                        <div className="col-md-4 col-sm-6">
                            <MetricCard
                                title="Sack emptying count"
                                value={displayMetrics.totalSackCount}
                                icon={<FiShoppingBag className="metric-icon green" />}
                            />
                        </div>
                    </div>

                    {/* Tables container */}
                    <div className="row mt-4">
                        {/* Sack Count Table */}
                        <div className="col-lg-12 col-md-12 mb-2">
                            <div style={tableContainerStyle}>
                                {/* Shift Filter */}
                                <div style={filterContainerStyle}>
                                    <div></div>
                                    <div></div>
                                    <div className="d-flex align-items-center">
                                        <span className="me-2">Filter by Shift:</span>
                                        <Dropdown
                                            value={shiftFilter}
                                            options={shiftOptions}
                                            onChange={(e) => setShiftFilter(e.value)}
                                            placeholder="Select Shift"
                                            className="p-dropdown-sm"
                                            style={{ width: "150px" }}
                                        />
                                    </div>
                                </div>

                                {error && (
                                    <div className="alert alert-danger" role="alert">
                                        {error}
                                    </div>
                                )}

                                <DataTable
                                    value={data}
                                    scrollable
                                    scrollHeight="250px"
                                    className="p-datatable-sm p-datatable-striped"
                                    emptyMessage="No records found for selected date range"
                                    responsiveLayout="scroll"
                                    loading={loading}
                                >
                                    <Column
                                        header="Sr. No."
                                        style={{ width: "5%" }}
                                        bodyStyle={{ textAlign: "right" }}
                                        body={(rowData, options) => (
                                            <span>
                                                {(pagination.currentPage - 1) * pagination.rowsPerPage +
                                                    options.rowIndex +
                                                    1}
                                            </span>
                                        )}
                                    />
                                    <Column field="date" header="Date" style={{ width: "12%" }} />
                                    <Column
                                        field="time"
                                        header="Time"
                                        style={{ width: "15%" }}
                                        body={(rowData) => (
                                            <span
                                                style={{ cursor: "pointer", color: "black" }}
                                                onClick={() => {
                                                    setShowModal(true);
                                                    setSelectedImage("/Sack_Count.png");
                                                    setModalTitle("Sack Emptying Count Details");
                                                }}
                                            >
                                                {rowData.time}
                                            </span>
                                        )}
                                    />
                                    <Column
                                        field="shift"
                                        header="Shift"
                                        style={{ width: "7%" }}
                                        bodyStyle={{ backgroundColor: "rgb(214, 249, 255)", textAlign: "center" }}
                                    />
                                    <Column
                                        field="sack"
                                        header="Detected Sack Count"
                                        style={{ width: "15%" }}
                                        bodyStyle={{ backgroundColor: "rgba(233, 236, 239, 0.7)", textAlign: "right" }}
                                    />
                                    <Column
                                        header="Actual Sack Count"
                                        style={{ width: "15%" }}
                                        body={(rowData) => (
                                            <input
                                                key={`${rowData.date}_${rowData.time}`}
                                                type="text"
                                                inputMode="numeric"
                                                defaultValue={rowData.actual_sack_count != null && rowData.actual_sack_count !== "" ? rowData.actual_sack_count : ""}
                                                onChange={(e) =>
                                                    handleActualCountChange(
                                                        `${rowData.date}_${rowData.time}`,
                                                        e.target.value
                                                    )
                                                }
                                                placeholder="Enter count"
                                                style={{
                                                    width: "100%",
                                                    padding: "4px 8px",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "4px",
                                                    textAlign: "right",
                                                }}
                                            />
                                        )}
                                    />
                                    <Column
                                        header="Action"
                                        style={{ width: "7%" }}
                                        bodyStyle={{ textAlign: "center" }}
                                        body={(rowData) => (
                                            <RowSaveButton
                                                key={`${rowData.date}_${rowData.time}`}
                                                rowKey={`${rowData.date}_${rowData.time}`}
                                                saveCallbacksRef={saveCallbacksRef}
                                                onSave={() => handleSaveActualCount(rowData)}
                                                hasExistingValue={rowData.actual_sack_count != null && rowData.actual_sack_count !== ""}
                                            />
                                        )}
                                    />
                                </DataTable>

                                <div style={paginationContainerStyle}>
                                    {/* Responsive pagination layout */}
                                    <div className="row align-items-center">
                                        <div className="col-sm-6 mb-2 mb-sm-0">
                                            <div className="d-flex align-items-center">
                                                <span className="me-2 d-none d-sm-inline">Rows:</span>
                                                <select
                                                    value={pagination.rowsPerPage}
                                                    onChange={handleRowsPerPageChange}
                                                    className="form-select form-select-sm"
                                                    style={{ width: "70px" }}
                                                    disabled={loading}
                                                >
                                                    <option value="5">5</option>
                                                    <option value="10">10</option>
                                                    <option value="20">20</option>
                                                    <option value="50">50</option>
                                                </select>
                                                <span className="ms-3 text-muted">
                                                    Total: {pagination.totalRecords} records
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="d-flex align-items-center justify-content-sm-end justify-content-center gap-2">
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() =>
                                                        handlePageChange(pagination.currentPage - 1)
                                                    }
                                                    disabled={pagination.currentPage === 1 || loading}
                                                >
                                                    {"<<"}
                                                </button>
                                                <span className="small">
                                                    Page {pagination.currentPage}/
                                                    {pagination.totalPages || 1}
                                                </span>
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() =>
                                                        handlePageChange(pagination.currentPage + 1)
                                                    }
                                                    disabled={
                                                        pagination.currentPage === pagination.totalPages ||
                                                        pagination.totalPages === 0 ||
                                                        loading
                                                    }
                                                >
                                                    {">>"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CSS for custom styling */}
            <style jsx>{`
        .hide-scrollbar {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }

        :global(.p-calendar-range) {
          min-width: 240px;
        }

        :global(.p-calendar-range .p-inputtext) {
          font-size: 14px;
        }

        :global(.p-button-sm) {
          font-size: 14px;
          padding: 0.4rem 0.8rem;
        }

        :global(.p-dropdown-sm .p-dropdown-label) {
          font-size: 14px;
          padding: 0.4rem 0.8rem;
        }

        @media (max-width: 768px) {
          :global(.p-calendar-range) {
            width: 100%;
            margin-bottom: 10px;
          }
        }
      `}</style>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle || "Coriander Details"}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <img
                        src={selectedImage}
                        alt="Coriander Details"
                        className="img-fluid rounded shadow"
                    />
                </Modal.Body>
                <Modal.Footer>Tracking ID: ABCDQWERTY12345</Modal.Footer>
            </Modal>
        </div>
    );
}
